<svg class="diag-graphe-v2-consommation" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 330 260">
    <defs>
        <style>
            .diag-graphe-v2-consommation .a {
                fill: #00a06d;
            }

            .diag-graphe-v2-consommation .b {
                fill: #52b153;
            }

            .diag-graphe-v2-consommation .c {
                fill: #a5cc74;
            }

            .diag-graphe-v2-consommation .d {
                fill: #f4e70f;
            }

            .diag-graphe-v2-consommation .e {
                fill: #f0b40f;
            }

            .diag-graphe-v2-consommation .f {
                fill: #eb8235;
            }

            .diag-graphe-v2-consommation .g {
                fill: #d7221f;
            }

            .diag-graphe-v2-consommation .line-black {
                fill: none;
                stroke: #1d1d1b;
                stroke-miterlimit: 10;
                stroke-width: 1.42px;
            }

            .diag-graphe-v2-consommation .value {
                fill: #1d1d1b;
            }

            .diag-graphe-v2-consommation .white {
                fill: #fff;
            }
        </style>
    </defs>

    <title>Performance énergétique</title>

    <!-- A -->
    <text x="110" y="18" class="a" font-size="8" font-weight="bold">logement extrêmement performant</text>
    <polygon class="a" points="156.72 45.69 110.72 45.69 110.72 22.22 156.72 22.22 164.66 33.95 156.72 45.69"/>
    <path class="white" d="M126.52,41.21l-1-3.32h-4.67l-1,3.32h-3.08l4.61-14h3.76l4.54,14ZM123.21,30h-.09l-1.54,5.3h3.2Z"/>

    <!-- B -->
    <polygon class="b" points="175.11 72.37 110.72 72.37 110.72 48.9 175.11 48.9 183.05 60.64 175.11 72.37"/>
    <path class="white"
          d="M118.09,53.93h6.79a3.38,3.38,0,0,1,3.68,3.58c0,2.14-1.18,2.94-2.6,3v.12a3.09,3.09,0,0,1,3.14,3.28,3.76,3.76,0,0,1-3.6,4h-7.41Zm3,5.72h3a1.18,1.18,0,0,0,1.28-1.28v-.6a1.18,1.18,0,0,0-1.28-1.28h-3Zm0,5.68h3.51a1.18,1.18,0,0,0,1.3-1.26v-.68a1.18,1.18,0,0,0-1.3-1.26h-3.51Z"/>

    <!-- C -->
    <polygon class="c" points="193.35 99.05 110.72 99.05 110.72 75.58 193.35 75.58 201.29 87.32 193.35 99.05"/>
    <path class="white"
          d="M117.71,87.21c0-4.72,2.42-7.32,6.19-7.32a5.17,5.17,0,0,1,5.22,3.28l-2.62,1.36a2.47,2.47,0,0,0-2.6-1.94c-1.78,0-3,1.2-3,3.4v2.24c0,2.2,1.19,3.4,3,3.4a2.87,2.87,0,0,0,2.78-2.08L129.16,91a5.46,5.46,0,0,1-5.26,3.34C120.13,94.33,117.71,91.93,117.71,87.21Z"/>

    <!-- D -->
    <polygon class="d" points="211.6 125.73 110.72 125.73 110.72 102.26 211.6 102.26 219.55 114 211.6 125.73"/>
    <path class="white"
          d="M117.79,106.82h5.27c3.7,0,6.14,2.34,6.14,7s-2.44,7-6.14,7h-5.27Zm5.27,11.26c1.8,0,2.92-1,2.92-3.2v-2.16c0-2.22-1.12-3.2-2.92-3.2h-2.23v8.56Z"/>

    <!-- E -->
    <polygon class="e" points="229.88 152.42 110.72 152.42 110.72 128.94 229.88 128.94 237.82 140.68 229.88 152.42"/>
    <path class="white" d="M118.69,147.64v-14h9.51v2.7h-6.46v2.87h5.54v2.67h-5.54v3h6.46v2.7Z"/>

    <!-- F -->
    <polygon class="f" points="111.44 200.27 111.44 156.33 248.42 156.33 263.39 178.3 248.42 200.27 111.44 200.27"/>
    <path class="value"
          d="M248,157l14.49,21.26L248,199.56H112.14V157H248m.75-1.41H110.73V201H248.79l15.45-22.68-15.45-22.67Z"/>

    <!-- G -->
    <polygon class="g" points="282.51 227.66 110.72 227.66 110.72 204.19 282.51 204.19 290.56 215.92 282.51 227.66"/>
    <path class="white"
          d="M126.44,220.73h-.1c-.2,1.4-1.48,2.46-3.58,2.46-3.21,0-5.73-2.48-5.73-7.16s2.55-7.28,6.33-7.28a5.59,5.59,0,0,1,5.38,3.24l-2.48,1.42a2.89,2.89,0,0,0-2.9-2c-1.88,0-3.11,1.08-3.11,3.4v2.24c0,2.32,1.23,3.4,3.11,3.4,1.52,0,2.74-.72,2.74-2.08v-.7h-2.6v-2.54H129V223h-2.56Z"/>
    <text x="110" y="238" class="g" font-size="8" font-weight="bold">logement extrêmement peu performant</text>

    <!-- Logo -->
    <g transform="translate(220,65)" font-size="9" class="g">
        <text x="0" y="0">Logement à consommation</text><text x="21" y="12">énergétique excessive</text>
    </g>
    <path class="g"
          d="M270.4,118.7a1,1,0,0,1-.44-.1.92.92,0,0,1-.4-1.25,10.15,10.15,0,0,1,16.92,0,.92.92,0,0,1-.4,1.25,1,1,0,0,1-1.27-.39,8.27,8.27,0,0,0-13.58,0,.93.93,0,0,1-.83.49"/>
    <path class="g" d="M272,106.64a1.48,1.48,0,1,1-1.51,1.48,1.5,1.5,0,0,1,1.51-1.48"/>
    <path class="g" d="M284.06,106.64a1.48,1.48,0,1,1-1.51,1.48,1.49,1.49,0,0,1,1.51-1.48"/>
    <polygon class="g"
             points="265.22 111.15 265.22 108.99 260.65 108.99 260.65 107.92 257.82 110.07 260.65 112.22 260.65 111.15 265.22 111.15"/>
    <polygon class="g"
             points="265.22 116.83 265.22 114.68 260.65 114.68 260.65 113.61 257.82 115.76 260.65 117.91 260.65 116.83 265.22 116.83"/>
    <polygon class="g"
             points="290.57 111.15 290.57 108.99 295.14 108.99 295.14 107.92 297.97 110.07 295.14 112.22 295.14 111.15 290.57 111.15"/>
    <polygon class="g"
             points="290.57 116.83 290.57 114.68 295.14 114.68 295.14 113.61 297.97 115.76 295.14 117.91 295.14 116.83 290.57 116.83"/>
    <polygon class="g"
             points="279.83 121.31 282.03 121.31 282.03 125.77 283.13 125.77 280.93 128.54 278.73 125.77 279.83 125.77 279.83 121.31"/>
    <polygon class="g"
             points="274.01 121.31 276.21 121.31 276.21 125.77 277.31 125.77 275.11 128.54 272.91 125.77 274.01 125.77 274.01 121.31"/>
    <polygon class="g"
             points="283.35 97.83 281.79 96.31 285.02 93.15 284.25 92.39 287.81 91.95 287.36 95.43 286.58 94.67 283.35 97.83"/>
    <polygon class="g"
             points="287.47 101.85 285.91 100.33 289.14 97.17 288.37 96.42 291.92 95.98 291.47 99.45 290.7 98.69 287.47 101.85"/>
    <polygon class="g"
             points="269.59 100.33 268.03 101.85 264.8 98.7 264.03 99.45 263.58 95.98 267.13 96.42 266.36 97.17 269.59 100.33"/>
    <polygon class="g"
             points="273.71 96.31 272.15 97.83 268.92 94.67 268.14 95.43 267.69 91.95 271.25 92.39 270.48 93.15 273.71 96.31"/>
    <polygon class="g" points="270.1 96.57 268.3 98.33 269.25 99.25 271.05 97.49 270.1 96.57"/>
    <rect class="g" x="276.75" y="122.77" width="2.55" height="1.31"/>
    <rect class="g" x="292.51" y="111.67" width="1.34" height="2.49"/>
    <polygon class="g" points="286.42 99.09 287.37 98.17 285.57 96.41 284.62 97.33 286.42 99.09"/>
    <path class="g" d="M288.74,101.35l3.77,3.69v3.43h1.33v-3.71a.66.66,0,0,0-.19-.46l-4-3.87Z"/>
    <path class="g" d="M273.36,95.23l4.56-4.45,4.39,4.29.94-.93-4.86-4.75a.68.68,0,0,0-.94,0l-5,4.92Z"/>
    <path class="g" d="M292.51,117.36v5.41h-9.94v1.31h10.61a.65.65,0,0,0,.66-.65v-6.07Z"/>
    <path class="g" d="M273.47,122.77H263.33v-5.41H262v6.07a.66.66,0,0,0,.67.65h10.81Z"/>
    <path class="g" d="M263.33,108.47V105l3.6-3.52-.94-.93-3.8,3.71a.65.65,0,0,0-.2.46v3.71Z"/>
    <rect class="g" x="261.99" y="111.67" width="1.34" height="2.49"/>

    <!-- Lignes logo -->
    <path class="line-black" d="M277.9,134.38A24.88,24.88,0,1,0,253,109.5,24.88,24.88,0,0,0,277.9,134.38Z"/>
    <path class="line-black" d="M277.86,134.42v38.21s0,5.67-5.67,5.67h-9.63"/>

    <!-- Lignes données -->
    <line class="line-black" x1="65.13" y1="159.52" x2="65.13" y2="197.08"/>
    <path class="value"
          d="M110.72,157v42.52H15.88a2.4,2.4,0,0,1-2.4-2.4V159.45a2.4,2.4,0,0,1,2.4-2.41h94.84m1.42-1.41H15.88a3.82,3.82,0,0,0-3.82,3.82v37.71A3.82,3.82,0,0,0,15.88,201h96.26V155.63Z"/>
    <path class="white"
          d="M119.44,193.8a.71.71,0,0,1-.71-.71V163.77a.71.71,0,0,1,.71-.71h19.45a.71.71,0,0,1,.71.71v5.67a.71.71,0,0,1-.71.71H126.53v4.59H137a.71.71,0,0,1,.71.71v5.63a.71.71,0,0,1-.71.71H126.53v11.3a.7.7,0,0,1-.7.71Z"/>
    <path class="value"
          d="M138.89,163.77v5.67H125.83v6H137v5.63H125.83v12h-6.39V163.77h19.45m0-1.41H119.44a1.42,1.42,0,0,0-1.42,1.41v29.32a1.42,1.42,0,0,0,1.42,1.42h6.39a1.41,1.41,0,0,0,1.41-1.42V182.5H137a1.43,1.43,0,0,0,1.42-1.42v-5.63A1.43,1.43,0,0,0,137,174h-9.72v-3.17h11.65a1.42,1.42,0,0,0,1.42-1.42v-5.67a1.42,1.42,0,0,0-1.42-1.41Z"/>

    <!-- Données -->
    <g *ngIf="consommation >= 0" transform="translate(40,169)" font-weight="bold" text-anchor="middle">
        <text x="0" y="5" alignment-baseline="middle" font-size="20">{{consommation}}</text>
        <text x="0" y="20" alignment-baseline="middle" font-size="7">kWh/m²/an</text>
        <text x="0" y="38" alignment-baseline="middle" font-size="7">consommation</text>
        <text x="0" y="48" alignment-baseline="middle" font-size="7" fill="#9d9d9c" font-weight="normal">
            (énergie primaire)
        </text>
    </g>

    <!-- Données -->
    <g *ngIf="emissions >= 0" transform="translate(88,169)" font-weight="bold" text-anchor="middle">
        <text x="0" y="5" alignment-baseline="middle" font-size="20">{{emissions}}</text>
        <text x="0" y="20" alignment-baseline="middle" font-size="7">
            kg CO<tspan dy="5">²</tspan><tspan dy="-3.5px">/m²/an</tspan>
        </text>
        <text x="0" y="38" alignment-baseline="middle" font-size="7">émissions</text>
    </g>
</svg>
